/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Updated_CaseInputs */

const en_stage_updated_case = /** @type {(inputs: Stage_Updated_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case stage updated successfully`)
};

const pt_br2_stage_updated_case = /** @type {(inputs: Stage_Updated_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa do caso atualizada com sucesso`)
};

/**
* | output |
* | --- |
* | "Case stage updated successfully" |
*
* @param {Stage_Updated_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_updated_case = /** @type {((inputs?: Stage_Updated_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Updated_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_updated_case(inputs)
	return pt_br2_stage_updated_case(inputs)
});